import React from 'react';
import topImage from '../../assets/header.png';

const HeroSection = () => {
  const scrollToApplySection = () => {
    const element = document.getElementById('apply-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          <div className="typing-animation typing-1" style={{opacity: 1, width: "100%", whiteSpace: "normal"}}>Start-Up Nation 2025 – 2026</div>
          <div className="typing-animation typing-1" style={{opacity: 1, width: "100%", whiteSpace: "normal"}}>Ediția a 2-a</div>
          <div className="typing-animation typing-2" style={{opacity: 1, width: "100%", whiteSpace: "normal"}}>Curs gratuit de antreprenoriat</div>
        </h1>
        <p className="hero-subtitle hide-on-mobile" style={{opacity: 1, transform: "none", color: "#222"}}>Ai între 18 și 29 de ani? Înscrierile la cursul gratuit de 40 de ore sunt deschise. Cu certificatul obținut, îți poți deschide firma și poți aplica la un grant de până la 250.000 lei.</p>
        <a href="#apply-section" onClick={scrollToApplySection} className="btn hero-cta desktop-cta" style={{opacity: 1, transform: "none"}}>Rezervă-ți locul</a>
      </div>
      
      <div className="hero-image" style={{opacity: 1, transform: "none"}}>
        <img src={topImage} alt="Start-Up Nation 2025-2026, Ediția a 2-a - curs de antreprenoriat" loading="eager" style={{display: "block"}} />
      </div>

      {/* Buton pentru versiunea mobilă care apare sub imagine */}
      <div className="mobile-cta-container">
        <a href="#apply-section" onClick={scrollToApplySection} className="btn hero-cta mobile-cta" style={{opacity: 1, transform: "none"}}>Rezervă-ți locul</a>
        
        {/* Text pentru versiunea mobilă - apare doar pe ecrane mici */}
        <p className="mobile-hero-text mt-4 text-gray-800 font-medium text-center">
          Ai între 18 și 29 de ani? Înscrierile la cursul gratuit de 40 de ore sunt deschise. Cu certificatul obținut, îți poți deschide firma și poți aplica la un grant de până la 250.000 lei.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;